import React, { Component } from 'react'
import styled from 'styled-components'
import { FlexWrapper, Card, Circle, StyledImage, DefaultText, XXXMText, XMText } from '../components'
const StyledCircle = styled(Circle)`
  overflow: hidden;
  min-width: 80px;
`
class TeamCard extends Component {
  state = {}
  render() {
    const { name, image, position, description, background, ...props } = this.props
    return (
      <Card
        boxRadius="5px"
        boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)"
        padding="16px"
        margin="10px 0 0 0"
        bgColor={background ? '#124b5f' : '#078489'}
        {...props}>
        <FlexWrapper direction="row">
          <StyledCircle size="80px">
            <StyledImage src={image} alt="team" height="76px" maxWidth="76px" borderRadius="50%" objectFit="cover" />
          </StyledCircle>
          <FlexWrapper viewPadding="0px 0 0 20px">
            <DefaultText color="#fff">{name}</DefaultText>
            <XXXMText color={background ? '#078489' : 'rgba(255, 255, 255, 0.6)'}>{position}</XXXMText>
            <XMText color="#fff">{description}</XMText>
          </FlexWrapper>
        </FlexWrapper>
      </Card>
    )
  }
}

export default TeamCard



// WEBPACK FOOTER //
// ./src/components/TeamCard.js